import axios from "axios";

const baseurl = "https://j.kalejoy.com/kalejoy"; //测试环境

const service = axios.create({
  baseURL: baseurl,
  timeout: 1000 * 60,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  },
});

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use((response) => {
  return response.data.data;
}, (error) => {
   return Promise.reject(error)
});

export default service